var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.713,
    height: 22.892,
    viewBox: "0 0 18.713 22.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.535,6h2.089a2.089,2.089,0,0,1,2.089,2.089V22.713A2.089,2.089,0,0,1,20.624,24.8H8.089A2.089,2.089,0,0,1,6,22.713V8.089A2.089,2.089,0,0,1,8.089,6h2.089",
    transform: "translate(-6 -3.911)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.045,3h6.267a1.045,1.045,0,0,1,1.045,1.045V6.134a1.045,1.045,0,0,1-1.045,1.045H13.045A1.045,1.045,0,0,1,12,6.134V4.045A1.045,1.045,0,0,1,13.045,3Z",
    transform: "translate(-7.822 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.c932e1ee1cbd3ef0d3d68469d922bf83.svg";
export { ForwardRef as ReactComponent };